import axios, {AxiosRequestConfig} from 'axios';
import config from "../config";
// import {logoutUser} from "../slices/auth/login/thunk";

const {api} = config;

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// Request interceptor
axios.interceptors.request.use(
    (config) => {
        const token = getAuthToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// intercepting to capture errors
axios.interceptors.response.use(
    function (response) {
        return response.data;
    },
    function (error: any) {
        const status = error?.response?.status ?? error?.status;

        if (status) {
            error.status = status;
        }

        if (status === 401) {
            logoutUser();
        }

        return Promise.reject(error);
    }
);
class APIClient {
    /**
     * Fetches data from the given URL
     */

    get = <T = any>(url: string, params?: any): Promise<T> => {
        return axios.get<T, T>(`${url}`, params ? {params} : undefined);
    };

    /**
     * Posts the given data to the URL
     */
    create = <T = any, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<T> => {
        return axios.post<T, T, D>(url, data as D, config);
    };

    /**
     * Updates data
     */
    update = <T = any, D = any>(url: string, data: D, config?: AxiosRequestConfig<D>): Promise<T> => {
        return axios.patch<T, T, D>(url, data, config);
    };

    put = <T = any, D = any>(url: string, data: D, config?: AxiosRequestConfig<D>): Promise<T> => {
        return axios.put<T, T, D>(url, data, config);
    };

    /**
     * Deletes data
     */
    delete = <T = any>(url: string, config?: AxiosRequestConfig): Promise<T> => {
        return axios.delete<T, T>(url, {...config});
    };
}

const getLoggedinUser = () => {
    const user = localStorage.getItem("authUser");
    if (!user) {
        return null;
    } else {
        try {
            return JSON.parse(user);
        } catch (error) {
            localStorage.removeItem("authUser");
            return null;
        }
    }
};

const clearAuthSession = () => {
    localStorage.removeItem("authUser");
    localStorage.removeItem("SelectedMerchant");
};

const getAuthToken = () => {
    const user = getLoggedinUser();

    const token = [
        user?.data?.token?.access_token,
        user?.token?.access_token,
        user?.token,
        user?.accessToken,
    ].find((candidate) => typeof candidate === "string" && candidate.trim().length > 0);

    return token || null;
};

const logoutUser = () => {
    clearAuthSession();

    if (window.location.pathname !== '/login') {
        // Redirect to login page or any specific logout page
        window.location.href = "/login"; // Adjust to your actual login route
    }

};

export {APIClient, getLoggedinUser, getAuthToken, clearAuthSession};
